import { Component } from '@angular/core';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  // Injected (not used directly here) purely so its constructor runs at
  // bootstrap and applies the persisted theme class before first paint —
  // otherwise nothing would ever instantiate this service until a shell's
  // theme-switcher UI is opened.
  constructor(_theme: ThemeService) {}
}
